import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint, faInfoCircle, faTruck } from "@fortawesome/free-solid-svg-icons";
import { DATE_FNS_LONG_DATE_FORMAT } from "../../../shared/constants";
import { WithTooltip } from "../../../shared/table-helpers";
import { Select } from "../../form-inputs/plain-inputs";
import { format } from "date-fns";

export const SHIPMENT_TYPE_MAP = {
    0: {
        label: "Physical",
        urlPath: "physical",
        isDigital: false,
    },
    1: {
        label: "Digital",
        urlPath: "digital",
        isDigital: true,
    },
    2: {
        label: "Digital Lite",
        urlPath: "digital",
        isDigital: true,
    },
};

export const SHIPMENT_FILTER_TYPES = [
    { text: "Show All", value: "-1" },
    { text: "Physical", value: "0" },
    { text: "Digital", value: "1" },
    { text: "Digital Lite", value: "2" },
];

export const DEFAULT_FILTER = [
    {
        id: "isRush",
        value: "all",
    },
];

export const DEFAULT_PAGE_SIZE = 10;

export const DEFAULT_SORT = [
    {
        id: "isCompleted",
        desc: false,
    },
    {
        id: "startDate",
        desc: false,
    },
    {
        id: "isRush",
        desc: true,
    },
];

export const getColumns = (locationDataSources) => [
    {
        Header: WithTooltip("Rush"),
        accessor: "isRush",
        Cell: (row) => {
            return row.value ? <FontAwesomeIcon icon={faTruck} /> : "";
        },
        filterMethod: (filter, row) => {
            const value = filter.value === "true";

            if (filter.value === "all") {
                return true;
            }

            return row[filter.id] === value;
        },
        Filter: ({ filter, onChange }) => {
            return (
                <select
                    onChange={(event) => onChange(event.target.value)}
                    style={{ width: "100%" }}
                    value={filter ? filter.value : "all"}
                >
                    <option value="all">Show All</option>
                    <option value="true">Is Rush</option>
                    <option value="false">Not Rush</option>
                </select>
            );
        },
    },
    {
        Header: WithTooltip("Start Date"),
        id: "exactDate",
        accessor: "startDate",
        Cell: (row) => {
            const dateString = row.value ? format(new Date(row.value), DATE_FNS_LONG_DATE_FORMAT) : "";

            return WithTooltip(dateString);
        },
        filterMethod: (filter, row) => {
            return format(new Date(row[filter.id]), DATE_FNS_LONG_DATE_FORMAT).startsWith(filter.value);
        },
    },

    {
        Header: WithTooltip("Receiver"),
        accessor: "receivedBy.name",
        Cell: (row) => {
            return WithTooltip(row.value);
        },
    },
    {
        Header: WithTooltip("Carrier"),
        accessor: "carrier.name",
        Cell: (row) => {
            return WithTooltip(row.value);
        },
    },
    {
        Header: WithTooltip("Client"),
        accessor: "client.name",
        Cell: (row) => {
            return WithTooltip(row.value);
        },
    },
    {
        Header: WithTooltip("CES Client"),
        accessor: "cxHClient.name",
        Cell: (row) => {
            return WithTooltip(row.value);
        },
    },
    {
        Header: WithTooltip("Supplier"),
        accessor: "supplier.name",
        Cell: (row) => {
            return WithTooltip(row.value);
        },
    },
    {
        Header: WithTooltip("Shipment Type"),
        accessor: "shipmentType",
        Cell: (row) => {
            const shipmentType = SHIPMENT_TYPE_MAP[row.original.shipmentType].label;

            return WithTooltip(shipmentType);
        },
        filterMethod: (filter, row) => {
            const value = Number(filter.value);

            if (filter.value < 0) {
                return true;
            }

            return row[filter.id] === value;
        },
        Filter: ({ filter, onChange }) => {
            return (
                <Select
                    onChange={(event) => onChange(event.target.value)}
                    style={{ width: "100%" }}
                    value={(filter && filter.value) || "all"}
                    id="select-type-filter"
                    options={SHIPMENT_FILTER_TYPES}
                    excludeSelect={true}
                />
            );
        },
    },
    {
        Header: WithTooltip("Source"),
        accessor: "locationDataSource",
        Cell: (row) => {
            return WithTooltip(row.value);
        },
        Filter: ({ filter, onChange }) => {
            return (
                <Select
                    onChange={(event) => onChange(event.target.value)}
                    style={{ width: "100%" }}
                    excludeSelect={false}
                    value={(filter && filter.value) || ""}
                    options={locationDataSources}
                />
            );
        },
    },
    {
        Header: WithTooltip("Status"),
        accessor: "isCompleted",
        Cell: (row) => {
            return row.original.isCompleted ? (
                <div className="button-group">
                    <a
                        href={`/bin-label/${row.original.key}`}
                        title="Print Label"
                        className="button -text"
                    >
                        <FontAwesomeIcon icon={faPrint} />
                    </a>
                    <a
                        href={`/shipment-status/${row.original.key}`}
                        title="Shipment Status"
                        className="button -text"
                    >
                        <FontAwesomeIcon icon={faInfoCircle} />
                    </a>
                </div>
            ) : (
                ""
            );
        },
        filterable: false,
    },
];
